export default "__VITE_ASSET___ljm6PyV__"